import React, { useState } from 'react';

import Riva from '../../../../assets/logos/podeMorar/RivaMobileLogo.svg';
import Direcional from '../../../../assets/logos/podeMorar/DirecionalMobileLogo.svg';
import MenuSandwitchIcon from '../../../../assets/icones/MenuSandwitch.svg';

import { NavbarSindicoContainer, ButtonMenuSandwitch } from './styles';
import { NavbarSindicoCenter, NavbarContainerItems } from '../styles';
import LeftNavbar from './LeftNavbar';

const NavbarSindicoMobile = ({
  goToHome,
  goToSolicitations,
  goToDocuments,
  handleLogoutSindico,
  activeRoute,
}) => {
  const [isLeftNavbarOpen, setIsLeftNavbarOpen] = useState(false);

  function openLeftNavBar() {
    setIsLeftNavbarOpen(true);
  }

  function closeLeftNavBar() {
    setIsLeftNavbarOpen(false);
  }

  return (
    <NavbarSindicoContainer>
      <NavbarSindicoCenter>
        <NavbarContainerItems>
          <img src={Direcional} />
          <img src={Riva} />
        </NavbarContainerItems>
        <NavbarContainerItems>
          <ButtonMenuSandwitch onClick={openLeftNavBar}>
            <img src={MenuSandwitchIcon} />
          </ButtonMenuSandwitch>
        </NavbarContainerItems>
        <LeftNavbar
          isOpen={isLeftNavbarOpen}
          close={closeLeftNavBar}
          goToHome={goToHome}
          goToSolicitations={goToSolicitations}
          goToDocuments={goToDocuments}
          handleLogoutSindico={handleLogoutSindico}
          activeRoute={activeRoute}
        />
      </NavbarSindicoCenter>
    </NavbarSindicoContainer>
  );
};

export default NavbarSindicoMobile;
